import { render } from "./ReasonForm.vue?vue&type=template&id=983ebcfa&scoped=true"
import script from "./ReasonForm.vue?vue&type=script&lang=js"
export * from "./ReasonForm.vue?vue&type=script&lang=js"

import "./ReasonForm.vue?vue&type=style&index=0&id=983ebcfa&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-983ebcfa"]])

export default __exports__